import styled from '@emotion/styled';
import React from 'react';

import { useSelector } from 'react-redux';

import { getCountries } from 'modules/countries/selectors';
import { getCountryTranslations } from 'modules/i18n/selectors/data';
import { Ellipsis } from 'ui/base';

import Flag from './Flag';

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    
    .name {
        width: 153px;
    }
    
    .prefix {
        width: 40px;
        text-align: right;
    }
`;

const SelectItem = ({ countryCode }) => {
  const countries = useSelector(getCountries);
  const countryTranslations = useSelector(getCountryTranslations);

  const { prefix } = countries[countryCode] ?? {};

  return (
    <Wrapper>
      <Flag countryCode={countryCode} className="w-5 flex-shrink-0" />
      <Ellipsis component="span" className="name">{countryTranslations[countryCode]}</Ellipsis>
      <span className="text-grey-50 prefix">+{prefix}</span>
    </Wrapper>
  );
};

export default SelectItem;
